import api from "@/api/v1-jwt/config/api";

const fetchBusinessTypes = async () => {
  const response = await api.get("/platform/application/business_type_list");
  return response.data.data;
};

const fetchRoleTitle = async () => {
  const response = await api.get("/platform/application/role_title_list");
  return response.data.data;
};

const fetchEstimatedMonthlySales = async () => {
  const response = await api.get(
    "/platform/application/est_monthly_sales_list"
  );
  return response.data.data;
};

const fetchNaicsList = async () => {
  const response = await api.get("/platform/application/naics_list");
  // Map NAICS schema fields to UI format: naics_code -> value, naics_description -> label
  return response.data.data.map((item) => ({
    value: item.naics_code,
    label: item.naics_description,
  }));
};

export const platformEndpoints = {
  fetchBusinessTypes,
  fetchRoleTitle,
  fetchEstimatedMonthlySales,
  fetchNaicsList,
};
